export default __webpack_public_path__ + "static/media/conquerorbg.fea46047.jpg";